import React from 'react';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import * as moment from 'moment';
import { Field, reduxForm, getFormValues } from 'redux-form';
import AsyncSelect from 'react-select/lib/Async';

class AssetForm extends React.Component {

  constructor() {
    super();
    this.state = {
      categoryID: 0
    };
  }

  componentDidMount() {
    const {
      initialValues: { assetCategory },
    } = this.props;

    if (assetCategory !== null) {
      this.setState({ categoryID: assetCategory.id });
    }
  }

  componentWillMount() {
    const {
      initialValues: { assetCategory },
    } = this.props;

    if (assetCategory !== null) {
      this.setState({ categoryID: assetCategory.id });
    }
  }

  renderField = ({
    input,
    label,
    placeholder,
    type,
    disabled,
    readOnly,
    meta: { touched, error, warning },
  }) => (
      <div className={`form-group ${error ? 'has-error' : ''}`}>
        <label className="col-md-2 control-label">{label}</label>
        <div className="col-md-10">
          <input
            {...input}
            className="form-control"
            placeholder={placeholder}
            type={type}
            disabled={disabled}
            readOnly={readOnly}
          />
          {touched &&
            ((error && <small className="help-block">{error}</small>) ||
              (warning && <small className="help-block">{warning}</small>))}
        </div>
      </div>
    );

  renderSelect = ({
    input,
    readOnly,
    meta: { touched, error, warning },
    label,
    children,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <select {...input} className="form-control" disabled={readOnly}>
          {children}
        </select>
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  renderLocationsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.searchLocations}
          getOptionValue={(option) => option.clinicLocationID}
          getOptionLabel={(option) => option.siteName}
          placeholder="Type Location Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onLocationChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onLocationChange = (val) => {
    this.props.change('location', val);
  }

  searchLocations = (search) => {
    return this.props.searchLocations(search, 'isActive');
  }

  renderClientsSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input,
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.searchClients}
          getOptionValue={(option) => option.employerCodeNumber}
          getOptionLabel={(option) => option.employerCodeDescription}
          placeholder="Type Client Name..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onClientChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onClientChange = (val) => {
    this.props.change('client', val);
  }

  searchClients = (search) => {
    return this.props.searchClients(search, 'isActive');
  }

  renderOwnerTypesSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.props.searchAssetOwnerTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onOwnerTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchAssetOwnerTypes = () => {
    return this.props.searchAssetOwnerTypes();
  }

  onOwnerTypeChange = (val) => {
    this.props.change('ownerType', val);
  }

  renderAssetTypesSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          key={this.state.categoryID}
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.searchAssetTypesByCategory}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Asset Type..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onAssetTypeChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchAssetTypesByCategory = () => {
    return this.props.searchAssetTypesByCategory(this.state.categoryID);
  }

  onAssetTypeChange = (val) => {
    this.props.change('assetType', val);
  }

  renderAssetCategoriesSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.props.searchAssetCategories}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder="Asset Category..."
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onAssetCategoryChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  searchAssetCategories = () => {
    return this.props.searchAssetCategories();
  }

  onAssetCategoryChange = (val) => {
    this.props.change('assetCategory', val);
    this.setState({ categoryID: val.id });
    this.props.change('assetType', null);
    this.props.searchAssetTypesByCategory(val.id);
  }

  renderResponsiblePartySelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.props.searchAssetOwnerTypes}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onResponsiblePartyChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onResponsiblePartyChange = (val) => {
    this.props.change('responsibleParty', val);
  }

  renderAssetStatusesSelect = ({
    meta: { touched, error, warning },
    label,
    readOnly,
    input
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <AsyncSelect
          value={input.value}
          cacheOptions
          defaultOptions
          isDisabled={readOnly}
          //isMulti
          loadOptions={this.props.searchAssetStatuses}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          placeholder={label}
          styles={{
            control: styles => ({
              ...styles,
              borderColor: touched && error ? 'red' : '#cccccc',
            }),
            menu: styles => ({
              ...styles,
              zIndex: 99999,
              color: '#108ee9',
            }),
          }}
          onChange={this.onAssetStatusChange}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  onAssetStatusChange = (val) => {
    this.props.change('assetStatus', val);
  }

  renderDateField = ({
    input,
    label,
    type,
    disabled,
    readOnly,
    maxLength,
    meta: { touched, error, warning },
  }) => (
    <div className={`form-group ${error ? 'has-error' : ''}`}>
      <label className="col-md-2 control-label">{label}</label>
      <div className="col-md-10">
        <DateTime
          timeFormat={false}
          viewDate={input.value}
          {...input}
          renderInput={(props, openCalendar, closeCalendar) => {
            const value =
              props.value && moment(props.value)
                ? moment(props.value).format('MM/DD/YYYY')
                : null;
            return (
              <div className="input-group">
                <input {...props} type="hidden" />
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  readOnly={readOnly}
                  disabled={disabled}
                  onFocus={openCalendar}
                />
                <span className="input-group-addon" onClick={openCalendar}>
                  <i className="fa fa-calendar" />
                </span>
              </div>
            );
          }}
          renderDay={(props, currentDate, selectedDate) => {
            return <td {...props}>{currentDate.date()}</td>;
          }}
          onChange={param => {
            if (param) {
              // console.log(param, param.format("YYYY-MM-DDThh:mm:ss"));
              input.onChange(param.format('YYYY-MM-DDTHH:mm:ss'));
            }
          }}
          disabled={disabled}
        />
        {touched &&
          ((error && <small className="help-block">{error}</small>) ||
            (warning && <small className="help-block">{warning}</small>))}
      </div>
    </div>
  );

  render() {
    const {
      handleSubmit,
      pristine,
      submitting,
      mode,
    } = this.props;

    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <fieldset>
          <legend>Asset</legend>
          <Field
            className="form-control"
            name="assetName"
            component={this.renderField}
            type="text"
            placeholder="Asset Name"
            label="Asset Name"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="assetTagNo"
            component={this.renderField}
            type="text"
            placeholder="Asset TagNo"
            label="Asset TagNo"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            name="assetCategory"
            component={this.renderAssetCategoriesSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Asset Category"
          />
          <Field
            key={this.state.categoryID}
            name="assetType"
            component={this.renderAssetTypesSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Asset Type"
          />
          <Field
            name="assetStatus"
            component={this.renderAssetStatusesSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Status"
          />
          <Field
            className="form-control"
            name="serial"
            component={this.renderField}
            type="text"
            placeholder="Serial"
            label="Serial"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="make"
            component={this.renderField}
            type="text"
            placeholder="Make"
            label="Make"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="model"
            component={this.renderField}
            type="text"
            placeholder="Model"
            label="Model"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="room"
            component={this.renderField}
            type="text"
            placeholder="Room"
            label="Room"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            name="ownerType"
            component={this.renderOwnerTypesSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Owner Type"
          />
          <Field
            name="responsibleParty"
            component={this.renderResponsiblePartySelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Responsible Party"
          />
          <Field
            className="form-control"
            name="serviceSchedule"
            component={this.renderField}
            type="text"
            placeholder="Calibration or Maintenance"
            label="Service Schedule"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="lastServiceDate"
            component={this.renderDateField}
            type="text"
            label="Service Date"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="vendor"
            component={this.renderField}
            type="text"
            placeholder="Vendor"
            label="Vendor"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="purchaseDate"
            component={this.renderDateField}
            type="text"
            label="Purchase Date"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="age"
            component={this.renderField}
            type="text"
            placeholder="Age"
            label="Age"
            disabled={true}
          />
          <Field
            className="form-control"
            name="eolDate"
            component={this.renderDateField}
            type="text"
            label="End Of Life Date"
            disabled={true}
          />
          <Field
            className="form-control"
            name="replacementCost"
            component={this.renderField}
            type="text"
            placeholder="ReplacementCost"
            label="ReplacementCost"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            className="form-control"
            name="businessPurpose"
            component={this.renderSelect}
            type="text"
            label="Business Purpose"
          >
            <option value="-1">Select</option>
            <option value="Critical">Critical</option>
            <option value="Non-Critical">Non-Critical</option>
          </Field>
          <Field
            className="form-control"
            name="phiData"
            component={this.renderSelect}
            type="text"
            label="PHI Data"
          >
            <option value="-1">Select</option>
            <option value="Y">Yes</option>
            <option value="N">No</option>
          </Field>
          <Field
            className="form-control"
            name="dataClassification"
            component={this.renderField}
            type="text"
            placeholder="Data Classification"
            label="Data Classification"
            readOnly={mode === 'ReadOnly' ? true : false}
          />
          <Field
            name="location"
            component={this.renderLocationsSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Locations"
          />
          <Field
            name="client"
            component={this.renderClientsSelect}
            readOnly={mode === 'ReadOnly' ? true : false}
            label="Clients"
          />

        </fieldset>

        <div className="form-actions">
          <div className="row">
            <div className="col-md-12">
              <button
                onClick={this.props.onCancel}
                className="btn btn-default"
                type="button"
              >
                Cancel
              </button>{' '}
              {/* <button className="btn btn-default" type="button" disabled={pristine || submitting} onClick={reset}>
                Reset</button>{" "} */}
              <button
                className="btn btn-primary"
                type="submit"
                disabled={pristine || submitting}
              >
                <i className="fa fa-save" /> Save
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
const validate = values => {
  const errors = {};
  if (!values.assetTagNo) {
    errors.assetTagNo = 'Required';
  }

  if (!values.ownerType) {
    errors.ownerType = 'Required';
  }
  //else {
  //  if (values.ownerType.name === 'Client' && !values.client) {
  //    errors.client = 'Required';
  //  }
  //}

  if (!values.assetType) {
    errors.assetType = 'Required';
  }

  if (!values.assetName) {
    errors.assetName = 'Required';
  }

  if (!values.assetStatus) {
    errors.assetStatus = 'Required';
  }

  if (!values.assetCategory) {
    errors.assetCategory = 'Required';
  }

  if (values.purchaseDate) {
    var dob = new Date(values.purchaseDate);
    //calculate month difference from current date in time  
    var month_diff = Date.now() - dob.getTime();

    //convert the calculated difference in date format  
    var age_dt = new Date(month_diff);

    //extract year from date      
    var year = age_dt.getUTCFullYear();

    //now calculate the age of the user  
    var age = Math.abs(year - 1970);
    values.age = age;

    var date = new Date(values.purchaseDate);
    values.eolDate = addYears(date, 5); 
  }

  return errors;
};

function addYears(date, years) {
  date.setFullYear(date.getFullYear() + years);
  return date;
}

AssetForm = connect(state => ({
  formValues: getFormValues('asset')(state),
  initialValues: state.assetmanager.asset,
  enableReinitialize: true,
  validate: validate,
}))(reduxForm({ form: 'asset' })(AssetForm));
export default AssetForm;



// WEBPACK FOOTER //
// ./src/routes/administration/components/AssetForm.js